enum TokenConstants {
  ACESSO_AUTORIZACAO = 'ext_acesso_autorizacao',
  CD_PESSOA_FISICA = 'ext_codigoPessoa',
  FIN_MENSALIDADE ='ext_fin_mensalidade',
  NR_SEQ_BENEFICIARIO = 'ext_nrSeqBeneficiario',
  ALTERACAO_CADASTRAL =  'ext_benef_alt_cadastral'
}

export default TokenConstants;
